import React from 'react'
import PropTypes from 'prop-types'

const MessageSpringIcon = (props) => {
  const {
    color = '#183560',
    classes = 'w-20',
    revert = false,
    notBackground = false,
    backgroundColor = '#ffffff',
  } = props

  const colorIcon = revert ? '#ffffff' : color
  const background = notBackground ? 'none' : revert ? color : backgroundColor

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <g clipPath="url(#clip0_1238_420)">
        <path
          d="M10 0.000213623C4.47734 0.000213623 0 4.47723 0 9.99992C0 15.5226 4.47734 19.9996 10 19.9996C15.5227 19.9996 20 15.5224 20 9.99992C20 4.47743 15.5229 0.000213623 10 0.000213623Z"
          fill={background}
        />
        <path
          d="M13.4648 11.3396C13.4159 10.3165 13.1859 9.36311 12.8441 8.59422C12.5764 9.39565 12.4269 10.3352 12.4379 11.3503C12.4625 13.6756 12.6782 14.9333 13.7479 14.9219C14.8176 14.9106 15.0038 13.6483 14.979 11.3237C14.9648 10.0316 14.6965 8.86328 14.2554 7.95589C14.6194 7.3632 15.0641 7.0233 15.4915 7.01834C15.6278 7.01694 15.7579 6.96196 15.8533 6.86549C15.9486 6.76902 16.0014 6.63896 16 6.50392C15.9986 6.36889 15.9431 6.23994 15.8457 6.14544C15.7484 6.05094 15.6172 5.99863 15.4809 6.00003C14.791 6.00697 14.1645 6.38179 13.6614 7.01695C13.145 6.39271 12.5104 6.03118 11.8206 6.03832C11.1309 6.04547 10.5046 6.42029 10.0017 7.05564C9.48497 6.431 8.8505 6.07027 8.16076 6.07741C7.47103 6.08456 6.84477 6.45898 6.34184 7.09394C5.82509 6.4697 5.19082 6.10856 4.49989 6.11571C4.36509 6.11936 4.23715 6.17537 4.14364 6.27166C4.05014 6.36795 3.99856 6.4968 4.00003 6.63043C4.0015 6.76406 4.0559 6.89176 4.15151 6.986C4.24711 7.08025 4.37626 7.13348 4.5111 7.13422C4.93895 7.12985 5.39203 7.46062 5.76823 8.04498C6.00428 8.47576 6.19829 8.98452 6.34604 9.53653C6.50755 10.1501 6.60318 10.7789 6.63134 11.4124C6.64656 12.8189 6.55246 13.4689 6.47117 13.7665C6.46096 13.7993 6.44294 13.8159 6.41451 13.8159C6.38608 13.8159 6.36706 13.7999 6.35685 13.7673C6.26796 13.4717 6.16004 12.8238 6.14503 11.4174C6.09598 10.3949 5.86613 9.44129 5.52437 8.6724C5.25609 9.47383 5.10633 10.4134 5.11754 11.4283C5.14257 13.7532 5.35779 15.0112 6.42753 14.9999C7.49726 14.9886 7.68446 13.7266 7.65903 11.4013C7.64542 10.1092 7.37713 8.94086 6.93527 8.03327C7.29925 7.44118 7.74412 7.10068 8.17158 7.09632C8.59903 7.09195 9.05251 7.42253 9.42811 8.00748V8.00867C9.66416 8.44004 9.85756 8.94761 10.0049 9.50002C10.1663 10.1126 10.2621 10.7403 10.291 11.3727C10.3058 12.779 10.2109 13.4286 10.1299 13.7268C10.1198 13.759 10.1026 13.7762 10.0732 13.7762C10.0438 13.7762 10.0267 13.76 10.0161 13.7278C9.92744 13.4318 9.82012 12.7839 9.80491 11.3779C9.75586 10.3548 9.52601 9.4014 9.18425 8.63251C8.91637 9.43414 8.76641 10.3739 8.77722 11.3886C8.80224 13.7137 9.01887 14.9714 10.0874 14.9602C11.1559 14.9491 11.3437 13.6874 11.3175 11.3622C11.3039 10.0703 11.0356 8.90177 10.5947 7.99418C10.9579 7.40229 11.403 7.06159 11.8307 7.05743C12.2583 7.05326 12.7116 7.38344 13.0872 7.96839C13.3236 8.39956 13.5178 8.90832 13.665 9.46034C13.8262 10.0734 13.9219 10.7017 13.9503 11.3346C13.9655 12.7409 13.8714 13.3907 13.7901 13.6885C13.7799 13.7209 13.7627 13.7378 13.7335 13.738C13.7042 13.7381 13.6868 13.7217 13.6758 13.6895C13.5875 13.3935 13.4798 12.7458 13.4646 11.3396"
          fill={colorIcon}
        />
      </g>
      <defs>
        <clipPath id="clip0_1238_420">
          <rect width="20" height="20" fill={background} />
        </clipPath>
      </defs>
    </svg>
  )
}

MessageSpringIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
  revert: PropTypes.bool,
  notBackground: PropTypes.bool,
  backgroundColor: PropTypes.string,
}

export default React.memo(MessageSpringIcon)
